import { lazyImport } from '@/shared/utils/lazy/lazy-import';
import { HeaderIcons } from './header';
import { SnsIcons } from './sns';
import { StatusIcons } from './status';
import { lazyImportSvg } from '@/shared/utils/lazy/lazy-import-svg';
import { SignInIcons } from './sign-in';
import AlertPopupIcons from '@/assets/icons/alert-popup';

export const Icons = {
  Logo: lazyImportSvg(() => import('./logo.svg')),
  MediPro: lazyImportSvg(() => import('./logo/logo.svg')),
  LogoBackground: lazyImportSvg(() => import('./logo/logo-background.svg')),
  Header: HeaderIcons,
  Sns: SnsIcons,
  Status: StatusIcons,
  AlertPopup: AlertPopupIcons,
  Check: lazyImportSvg(() => import('./check.svg')),
  Download: lazyImportSvg(() => import('./download.svg')),
  Edit: lazyImportSvg(() => import('./edit.svg')),
  Excel: lazyImportSvg(() => import('./excel.svg')),
  Follower: lazyImportSvg(() => import('./follower.svg')),
  InputClear: lazyImportSvg(() => import('./input-clear.svg')),
  Link: lazyImportSvg(() => import('./link.svg')),
  List: lazyImportSvg(() => import('./list.svg')),
  More: lazyImportSvg(() => import('./more.svg')),
  Search: lazyImportSvg(() => import('./search.svg')),
  SelectArrowDown: lazyImportSvg(() => import('./select-arrow-down.svg')),
  SortNone: lazyImportSvg(() => import('./sort-none.svg')),
  SortAsc: lazyImportSvg(() => import('./sort-asc.svg')),
  SortDesc: lazyImportSvg(() => import('./sort-desc.svg')),
  Star: lazyImportSvg(() => import('./star.svg')),
  TableRefresh: lazyImportSvg(() => import('./table-refresh.svg')),
  TagDelete: lazyImportSvg(() => import('./tag-delete.svg')),
  Close: lazyImport(() => import('@/shared/components/close-icon')),
  Heart: lazyImportSvg(() => import('./heart.svg')),
  SideBarArrow: lazyImportSvg(() => import('@/assets/icons/side-bar-arrow.svg')),
  Calendar: lazyImportSvg(() => import('./calendar.svg')),
  Video: lazyImportSvg(() => import('./video.svg')),
  Comment: lazyImportSvg(() => import('./comment.svg')),
  Eye: lazyImportSvg(() => import('./eye.svg')),
  Refresh: lazyImportSvg(() => import('./refresh.svg')),
  ViewOutlined: lazyImportSvg(() => import('./view-outlined.svg')),
  CommentOutlined: lazyImportSvg(() => import('./comment-outlined.svg')),
  HeartOutlined: lazyImportSvg(() => import('./heart-outlined.svg')),
  MailOutlined: lazyImportSvg(() => import('./mail-outlined.svg')),
  TrashCan: lazyImportSvg(() => import('./trash-can.svg')),
  ArrowCurveLeft: lazyImportSvg(() => import('./arrow-curve-left.svg')),
  MailOutlinedOpened: lazyImportSvg(() => import('./mail-outlined-opened.svg')),
  Send: lazyImportSvg(() => import('./send.svg')),
  FileXls: lazyImportSvg(() => import('./file-xls.svg')),
  Attach: lazyImportSvg(() => import('./attach.svg')),
  UploadCircle: lazyImportSvg(() => import('./upload-circle.svg')),
  TagPlus: lazyImportSvg(() => import('./tag-plus.svg')),
  TagMinus: lazyImportSvg(() => import('./tag-minus.svg')),
  Popular: lazyImportSvg(() => import('./popular.svg')),
  Blind: lazyImportSvg(() => import('./blind.svg')),
  Unblind: lazyImportSvg(() => import('./unblind.svg')),
  Detail: lazyImportSvg(() => import('./detail.svg')),
  Warning: lazyImportSvg(() => import('./warning.svg')),
  Error: lazyImportSvg(() => import('./error.svg')),
  EnrollArrowUp: lazyImportSvg(() => import('./enroll-arrow-up.svg')),
  Remove: lazyImportSvg(() => import('./remove.svg')),
  Dollar: lazyImportSvg(() => import('./dollar.svg')),
  ImageNotFound: lazyImportSvg(() => import('./image-not-found.svg')),
  Copy: lazyImportSvg(() => import('./copy.svg')),
  Pin: lazyImportSvg(() => import('./pin.svg')),
  Pdf: lazyImport(() => import('./pdf.svg')),
  Noti: lazyImport(() => import('./noti.svg')),
  RightArrowHead: lazyImport(() => import('./right-arrow-head.svg')),
  CheckAddress: lazyImportSvg(() => import('./check-address.svg')),
  ArrowLeft: lazyImportSvg(() => import('./arrow-left.svg')),
  PasswordInvisible: lazyImportSvg(() => import('./password-invisible.svg')),
  PasswordVisible: lazyImportSvg(() => import('./password-visible.svg')),
  Submit: lazyImportSvg(() => import('./submit.svg')),
  Emoji: lazyImport(() => import('./emoji.svg')),
  EmojiPlus: lazyImport(() => import('./emoji-plus.svg')),
  ErrorModal: lazyImport(() => import('./error-modal.svg')),
  SignIn: SignInIcons,
  MediaEmpty: lazyImport(() => import('./media-empty.svg')),
  SendMail: lazyImport(() => import('./send-mail.svg')),
  Camera: lazyImport(() => import('./camera.svg')),
  CameraOutline: lazyImport(() => import('./camera-outline.svg')),
  Kebab: lazyImport(() => import('./kebab.svg')),
  FileUpload: lazyImportSvg(() => import('./file-upload.svg')),
  Gallery: lazyImport(() => import('./gallery.svg')),
};
